import { useLocale } from "../lib/i18n";

export function Loading() {
  const { t } = useLocale();
  return (
    <div className="grid place-items-center rounded-xl border border-slate-200 bg-white py-12">
      <div className="flex items-center gap-3 text-slate-500">
        <span className="inline-block h-3 w-3 animate-pulse rounded-full bg-slate-400" />
        <span className="text-sm">{t.loading}</span>
      </div>
    </div>
  );
}

export function ErrorPanel({
  message,
  onRetry,
}: {
  message: string;
  /** When provided, renders a "Try again" button below the message. */
  onRetry?: () => void;
}) {
  const { t } = useLocale();
  return (
    <div className="rounded-xl border border-rose-200 bg-rose-50 p-6">
      <p className="text-sm font-semibold text-rose-700">{t.error}</p>
      <p className="mt-1 text-sm text-rose-600">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 rounded-lg border border-rose-300 bg-white px-3 py-1.5 text-sm font-medium text-rose-700 hover:bg-rose-100"
        >
          Try again
        </button>
      )}
    </div>
  );
}
